import { useState, useEffect, useContext } from 'react';
import { SearchContext } from '@elastic/react-search-ui';
import type { SearchDriver, SearchState, Filter } from '@elastic/search-ui';

export const useSearchState = (field?: string) => {
  const { driver } = useContext(SearchContext) as { driver: SearchDriver };
  const [currentState, setCurrentState] = useState<SearchState | null>(null);
  const [selectedValues, setSelectedValues] = useState<Set<string>>(new Set());

  useEffect(() => {
    const handleStateChange = (state: SearchState) => {
      setCurrentState(state);

      if (field) {
        const newSelectedValues = new Set<string>();
        if (state?.filters) {
          state.filters.forEach((filter: Filter) => {
            if (filter.field === field && Array.isArray(filter.values)) {
              filter.values.forEach((value: any) => {
                if (value != null && value !== undefined) {
                  newSelectedValues.add(value.toString());
                }
              });
            }
          });
        }
        setSelectedValues(newSelectedValues);
      }
    };

    driver.subscribeToStateChanges(handleStateChange);
    setCurrentState(driver.getState());

    return () => {
      // Cleanup if needed
    };
  }, [driver, field]);

  return { currentState, selectedValues, driver };
};
